import { toRecord } from './network-tool-card-utils';

function parseJsonValue(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
}

function readTextBlock(value: unknown): string | undefined {
  if (typeof value === 'string' && value.trim().length > 0) {
    return value;
  }

  const record = toRecord(value);
  const text = record?.text;

  return typeof text === 'string' && text.trim().length > 0 ? text : undefined;
}

export function unwrapMcpToolOutput(value: unknown): unknown {
  if (typeof value === 'string') {
    const parsed = parseJsonValue(value);

    return parsed !== undefined ? unwrapMcpToolOutput(parsed) : value;
  }

  if (Array.isArray(value)) {
    for (const block of value) {
      const text = readTextBlock(block);

      if (!text) {
        continue;
      }

      const parsed = parseJsonValue(text);

      if (parsed !== undefined) {
        return unwrapMcpToolOutput(parsed);
      }
    }

    return value;
  }

  const record = toRecord(value);

  if (!record) {
    return value;
  }

  if (record.lc === 1) {
    const kwargs = toRecord(record.kwargs);

    if (kwargs && kwargs.content !== undefined) {
      return unwrapMcpToolOutput(kwargs.content);
    }
  }

  if (Array.isArray(record.content) || typeof record.content === 'string') {
    return unwrapMcpToolOutput(record.content);
  }

  return record;
}
